import type { TagId } from "@gs/core/domain/Tag/Tag";
import { tagApi } from "../tagApi";
import { useTagStore } from "../tagStore";
import { createFindOrFetchForDomainHook } from "../../_utils/createFindOrFetchForDomainHook";

export const useFindOrFetchTag = createFindOrFetchForDomainHook({
  fetch: (ids: TagId[]) => tagApi.getTags({ limit: ids.length, offset: 0, filter: { id: ids, withDeleted: true } }),
  useStore: useTagStore,
});
